interface TopoProps {
  subtitulo?: string;
  passo?: string;
  aoVoltar?: () => void;
}

// Topo da página dos pais: voltar + título de 22 px + evento.
export default function Topo({ subtitulo, passo, aoVoltar }: TopoProps) {
  return (
    <header className="sticky top-0 z-30 border-b border-background-200 bg-background-100/95 backdrop-blur-md">
      <div className="mx-auto flex w-full max-w-[560px] items-start gap-3 px-4 py-3">
        {aoVoltar && (
          <button
            type="button"
            onClick={aoVoltar}
            aria-label="Voltar"
            className="aperta mt-0.5 flex h-11 w-11 shrink-0 cursor-pointer items-center justify-center rounded-full bg-background-50 text-foreground-800"
          >
            <i className="ri-arrow-left-line text-xl" aria-hidden />
          </button>
        )}
        <div className="min-w-0 flex-1">
          <h1 className="text-[22px] font-extrabold leading-tight text-foreground-950">
            Crianças no acampamento
          </h1>
          {subtitulo && (
            <p className="mt-0.5 truncate text-[13px] text-foreground-600">{subtitulo}</p>
          )}
          {passo && <p className="mt-0.5 text-[12px] font-medium text-foreground-500">{passo}</p>}
        </div>
      </div>
    </header>
  );
}